module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-500italic.woff?335c9c91b108673bd54f574969c1b7ae";